import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	left: 10px;
	top: 10px;
	width: 100px;
	height: calc(100% - 20px);

	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export { StyledContainer as TabListContainer };
